import { useNavigate, useLocation } from 'react-router-dom';
import { useCallback } from 'react';

export function useNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const goToRoute = useCallback((route, options = {}) => {
    navigate(route, options);
  }, [navigate]);

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const goForward = useCallback(() => {
    navigate(1);
  }, [navigate]);

  const redirectToLogin = useCallback(() => {
    navigate('/login', { 
      replace: true, 
      state: { from: location } 
    });
  }, [navigate, location]);

  const redirectToDashboard = useCallback(() => {
    navigate('/dashboard', { replace: true });
  }, [navigate]);

  const getCurrentPath = useCallback(() => {
    return location.pathname;
  }, [location]);

  const getCurrentQuery = useCallback(() => {
    return new URLSearchParams(location.search);
  }, [location]);

  const isCurrentRoute = useCallback((route) => {
    return location.pathname === route;
  }, [location]);

  const navigateWithQuery = useCallback((route, query = {}) => {
    const searchParams = new URLSearchParams(query);
    navigate(`${route}?${searchParams.toString()}`);
  }, [navigate]);

  return {
    goToRoute,
    goBack,
    goForward,
    redirectToLogin,
    redirectToDashboard,
    getCurrentPath,
    getCurrentQuery,
    isCurrentRoute,
    navigateWithQuery,
    location
  };
}